import Forbidden from '../assets/images/403.svg'
import logo from '../assets/images/kwota-logo.svg'
import Lock from '../assets/images/lock.svg'

export const ASSETS = {
  FORBIDDEN: Forbidden,
  LOCK: Lock,
  LOGO: logo
}

export type SizeVariants = 'sm' | 'md' | 'lg';
